<template>
  <div v-if="author_description" class="magazine-article-author">
    <div class="magazine-article-author__info">
      <div v-if="getAuthorImage" class="magazine-article-author__info-image">
        <img :src="getAuthorImage" loading="lazy" :alt="author_name" />
      </div>

      <div class="magazine-article-author__info-content">
        <span>{{ t('magazine.authorAboutTitle') }}</span>
        {{ author_name }}
      </div>
    </div>

    <div class="magazine-article-author__description">
      {{ author_description }}
    </div>

    <div v-if="partner_link" class="magazine-article-author__link">
      <NuxtLink :to="`/p/${partner_link}/`">
        <LinkIcon />
        <span>{{ t('magazine.authorAboutLink') }}</span>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import LinkIcon from '~/assets/general/link-anchor-icon.svg?component'
import { StrapiMedia } from '~/utils/strapiImageGetters'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    // eslint-disable-next-line vue/prop-name-casing
    author_name?: string
    // eslint-disable-next-line vue/prop-name-casing
    author_description?: string
    // eslint-disable-next-line vue/prop-name-casing
    author_picture?: StrapiMedia
    // eslint-disable-next-line vue/prop-name-casing
    partner_image?: string
    // eslint-disable-next-line vue/prop-name-casing
    partner_link?: string
  }>(),
  {
    author_name: '',
    author_description: '',
    author_picture: undefined,
    partner_image: '',
    partner_link: '',
  }
)

const getAuthorImage = computed(() => {
  if (props?.author_picture?.formats?.thumbnail?.url) {
    return props.author_picture?.formats?.thumbnail?.url
  }

  return props.author_picture?.url || ''
})
</script>

<style lang="postcss" scoped>
.magazine-article-author {
  @apply mt-4 px-6 py-8 rounded-xl border border-stone-200 bg-[#fefff9];

  &__info {
    @apply flex justify-center items-center gap-2.5 mb-3.5;
  }

  &__info-image {
    @apply relative w-[48px] h-[48px] overflow-hidden rounded-xl;
    box-shadow: -2px 1px 0 0 #eaff90;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__info-content {
    @apply flex flex-col text-stone-800 text-base font-semibold;
    line-height: 150%;

    span {
      @apply text-stone-600 text-xs;
      line-height: 125%;
    }
  }

  &__description {
    @apply w-full mx-auto text-xs text-stone-600;
  }

  &__link {
    @apply flex justify-center mt-4;

    a {
      @apply flex items-center gap-1 cursor-pointer text-xs font-medium text-stone-600;

      &:hover {
        span {
          @apply underline;
        }
      }
    }
  }
}
</style>
